/**
 * /frontend/src/features/analytics/hooks/useCustomerAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getCustomerBehavior, getCustomerSegments, getCustomerVisitTrend } from '../api/customerAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads customer behavior analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useCustomerAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, granularity, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [behavior, segments, visitTrend] = await Promise.all([
      getCustomerBehavior(request, storeToken, storeUuid, startDate, endDate),
      getCustomerSegments(request, storeToken, storeUuid, startDate, endDate),
      getCustomerVisitTrend(request, storeToken, storeUuid, startDate, endDate, granularity),
    ]);
    return { behavior, segments, visitTrend };
  }, [endDate, granularity, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useCustomerAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useCustomerAnalytics;
